import { X } from "react-feather"
import moment from "moment"

const Empty = () => <div className="form-control seminar-control bg-light">-</div>

// Plain text field
const Detail = ({ label, value, wide }) => (
  <div className={wide ? "col-12" : "col-6"}>
    <div className="seminar-label">{label}</div>
    <div className="form-control seminar-control bg-light text-break">{value || "-"}</div>
  </div>
)

const TextAreaDetail = ({ label, value }) => (
  <div className="col-12">
    <div className="seminar-label">{label}</div>
    <textarea className="form-control seminar-control seminar-textarea bg-light" value={value || "-"} rows="3" readOnly />
  </div>
)

// Clickable link field
const LinkDetail = ({ label, url }) => (
  <div className="col-12">
    <div className="seminar-label">{label}</div>
    {url ? (
      <a href={url} target="_blank" rel="noreferrer" className="form-control seminar-control text-break">
        {url}
      </a>
    ) : (
      <Empty />
    )}
  </div>
)

// Photo field with link to full image
const PhotoDetail = ({ label, src, alt }) => (
  <div className="col-6 seminar-photo-col">
    <div className="seminar-label">{label}</div>
    {src ? (
      <div className="seminar-view-image-box">
        <a href={src} target="_blank" rel="noreferrer" className="seminar-view-image-link">
          <img src={src} alt={alt} loading="lazy" decoding="async" className="seminar-preview" />
        </a>
      </div>
    ) : (
      <Empty />
    )}
  </div>
)

export const UpcomingSeminarViewPopup = ({ UpcomingSeminarData, cancelbtn }) => {
  const data = UpcomingSeminarData?.data || {}
  const name = data.title || "Seminar"
  const date = data.seminarDate ? moment(data.seminarDate).format("DD/MM/YYYY") : ""
  const time = data.startTime && data.endTime
    ? `${moment(data.startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(data.endTime, "HH:mm:ss").format("hh:mm A")}`
    : ""
  const fromDate = data.fromDate ? moment(data.fromDate).format("DD/MM/YYYY") : ""
  const toDate = data.toDate ? moment(data.toDate).format("DD/MM/YYYY") : ""

  return (
    <div className="seminar-backdrop custom">
      <div className="modal-dialog modal-dialog-centered seminar-dialog">
        <div className="modal-content seminar-content">
          <div className="d-flex align-items-center justify-content-between seminar-header">
            <h6 className="m-0 fw-bold">View Seminar</h6>
            <button type="button" className="btn-close btn-close-white seminar-close" onClick={cancelbtn} aria-label="Close" />
          </div>

          <div className="seminar-body">
            <div className="row g-3">
              <Detail label="Title of Seminar" value={data.title} wide />
              <Detail label="Sub Title of Seminar" value={data.subTitle} wide />
              <Detail label="Select Day" value={data.selectDay || data.day} />
              <Detail label="Date" value={date || data.date} />
              <Detail label="Time" value={time || data.time} wide />
              <TextAreaDetail label="Description" value={data.description} />
              <TextAreaDetail label="Key Topics" value={data.keyTopics} />
              <Detail label="From Date" value={fromDate || data.fromDate} />
              <Detail label="To Date" value={toDate || data.toDate} />

              <PhotoDetail label="Seminar Photo" src={data.seminarPhotoPath || data.seminarPhoto} alt={`${name} seminar`} />
              <PhotoDetail label="Side Photo" src={data.sidePhotoPath || data.sidePhoto} alt={`${name} side`} />

              <LinkDetail label="Register link for Seminar" url={data.registerLink || data.registerForSeminar} />
              <LinkDetail label="Meeting Link" url={data.meetingLink} />
            </div>
          </div>

          <div className="d-flex justify-content-end seminar-footer">
            <button type="button" className="btn btn-danger seminar-btn-cancel" onClick={cancelbtn}>
              <X size={15} className="me-1" />
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}